import { useQuery } from '@apollo/client';
import GET_THEMES from './theme.gql';

export interface ITheme {
  theme_id: number;
  theme_name: string;
  theme_image: string;
  order: number;
}

interface IData {
  visibleThemes: ITheme[];
}

export const All_THEME = {
  theme_id: 0,
  theme_name: '전체',
  theme_image: '/images/theme_thumbs/TM0.png',
  order: 0,
};

export default function useThemes(): ITheme[] {
  const { data } = useQuery<IData>(GET_THEMES);
  const themes = data?.visibleThemes ?? [];
  return [All_THEME].concat(themes);
}
